import { cn } from "@/shared/libs/commonUtils";
import { Button } from "../button";
import PhosphorIcon from "../PhosphorIcon";
import { useCarousel } from "./CarouselContext";
import type { ComponentProps, ReactNode, Ref } from "react";

interface ICarouselPreviousProps extends ComponentProps<typeof Button> {
  ref?: Ref<HTMLButtonElement>;
  icon?: ReactNode;
}

export default function CarouselPrevious({
  ref,
  icon,
  className,
  variant = "outline",
  size = "icon",
  ...props
}: ICarouselPreviousProps) {
  const { orientation, scrollPrev, canScrollPrev } = useCarousel();
  return (
    <Button
      ref={ref}
      variant={variant}
      size={size}
      className={cn(
        "absolute h-8 w-8 !rounded-full",
        orientation === "horizontal"
          ? "-left-12 top-1/2 -translate-y-1/2"
          : "-top-12 left-1/2 -translate-x-1/2 rotate-90",
        className,
      )}
      disabled={!canScrollPrev}
      onClick={scrollPrev}
      {...props}
    >
      {icon ?? (
        <PhosphorIcon
          name="CaretLeft"
          size={20}
          className="text-muted-foreground"
        />
      )}
    </Button>
  );
}
